import { createRouter, createWebHistory } from 'vue-router';
import ContactForm from "@/pages/contact/ContactForm.vue"
import ContactThanks from "@/pages/contact/ContactThanks.vue"

const routes = [
    {
        path: '/contact/thanks',
        name: 'contactthanks',
        component: ContactThanks,
    },
    {
        path: '/contact/thanks/:landing',
        name: 'contactthankslanding',
        component: ContactThanks,
    },
    {
        path: '/contact',
        name: 'contactform',
        component: ContactForm,
    },
    {
        path: '/contact/:landing',
        name: 'contactformlanding',
        component: ContactForm,
    },
]

const router = createRouter({
    history: createWebHistory(),
    linkActiveClass: "active",
    linkExactActiveClass: "exactive",
    base: import.meta.env.BASE_URL,
    routes
})

export default router;
